'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./node_modules/history/lib/ExecutionEnvironment.js
// module id = 154
// module chunks = 0